import { TableToolbarButton } from '@shared';

/**
 * [TEMPORARY HIDDEN]: For tech magic
 */
export const TOOLBAR_BUTTONS: TableToolbarButton[] = [
    // {
    //     buttonName: 'Bulk Delete',
    //     icon: 'outline-trash',
    //     variant: 'primary',
    //     disabled: true,
    // },
    // {
    //     buttonName: 'Export',
    //     icon: 'export',
    //     variant: 'accent',
    // },
];

export const TOOLBAR_BUTTONS_SINGLE_PLAYLIST: TableToolbarButton[] = [
    {
        buttonName: 'Mark All',
        icon: 'outline-check',
        variant: 'primary',
        disabled: true,
    },
    {
        buttonName: 'Bulk Modify',
        icon: 'settings',
        variant: 'accent',
        disabled: true,
    },
    {
        buttonName: 'Bulk Delete',
        icon: 'outline-trash',
        variant: 'primary',
        disabled: true,
    },
];

export const VIEW_CONTROLS_BUTTON = [
    {
        icon: 'grid-view',
        action: 'grid',
    },
    {
        icon: 'list-view',
        action: 'list',
    },
];

/**
 * Layout constant for the fill-information step input fields
 */
export const FILL_INFORMATION_STEP_INPUTS = [
    {
        id: 'playlistName',
        label: 'Playlist Name',
        type: 'text',
        placeholder: 'Enter playlist name',
        required: true,
    },
    {
        id: 'playlistDescription',
        label: 'Playlist Description',
        type: 'text',
        placeholder: 'Enter playlist description',
        required: true,
    },
    {
        id: 'assignToDealer',
        label: 'Assign to Dealer',
        type: 'autocomplete',
        placeholder: 'Select dealer',
        required: true,
    },
];

/**
 * Tabs for the create playlist step - select assets
 */
export const SELECT_ASSETS_STEP_TABS = [
    {
        id: 'assignedToDealer',
        label: 'Assigned to Dealer',
        iconKey: 'play',
        iconSize: 14,
    },
    {
        id: 'floatingContents',
        label: 'Floating Contents',
    },
    {
        id: 'channelContents',
        label: 'Channels',
        iconKey: 'play',
        iconSize: 14,
    },
];
